import React from "react";

interface PrivacyPolicySkeletonProps {
  isVisible: boolean;
}

/**
 * Skeleton loader component for privacy policy content
 * Displays animated skeleton placeholders while iframes are loading
 */
export const PrivacyPolicySkeleton: React.FC<PrivacyPolicySkeletonProps> = ({
  isVisible,
}) => {
  if (!isVisible) {
    return null;
  }

  return (
    <div
      className={`privacy-policy__skeleton ${
        !isVisible ? "privacy-policy__skeleton-hidden" : ""
      }`}
    >
      {/* Skeleton Title */}
      <div className="privacy-policy__skeleton-title" />

      {/* Skeleton Paragraphs */}
      {[0, 1, 2, 3, 4, 5].map((paragraphIndex) => (
        <div
          key={`skeleton-paragraph-${paragraphIndex}`}
          className="privacy-policy__skeleton-paragraph"
        >
          {[0, 1, 2, 3].map((lineIndex) => {
            const isLastLine = lineIndex === 3;
            const lineClass = isLastLine
              ? "privacy-policy__skeleton-line--short"
              : "privacy-policy__skeleton-line--medium";
            return (
              <div
                key={`skeleton-line-${paragraphIndex}-${lineIndex}`}
                className={`privacy-policy__skeleton-line ${lineClass}`}
              />
            );
          })}
        </div>
      ))}
    </div>
  );
};
